import horsePeople from './IHWP_kentico';
import namespace from '../../smartpak/smartpak';
import swapNavTab from "./swapnavtab";

// just incase there are old references within content.
window.smartPak = window.smartPak || {};
namespace('kentico')._swapNavTab = swapNavTab;
window.smartPak.horsePeople = horsePeople;

swapNavTab();
horsePeople._init();
